import { FC } from 'react';

import styles from './CostInstruction.module.scss';

export const CostInstruction: FC = () => {
  return (
    <div className={styles.container} data-test-id="costInstruction-section">
      <h2 className={styles.title}>費用と手数料</h2>
      <div className={styles.headline}>
        <span>費用は見込み客への初回メッセージ送信のみです</span>
      </div>
      <div className={styles.content}>
        <div className={styles.sweet}>
          <div className={styles.commisions}>
            <span className={styles.col}>初期登録料</span>
            <span className={styles.col}>月額利用料</span>
            <span className={styles.col}>仲介手数料</span>
            <span className={styles.col}>成約手数料</span>
          </div>
          <div className={styles.nocost}>
            <span className={styles.emphasis}>0</span>円</div
          >
        </div>
        <div className={styles.bitter}>
          <div className={styles.instruction}>
            <p className={styles.primary}><span className={styles['line-break']}>見込み客への</span>初回メッセージ送信</p>
            <span className={styles.notice}>※依頼内容によって異なります</span>
          </div>
          <div className={styles['tax-included']}><span className={styles.emphasis}>167<sup>(税込)</sup><sub>円〜</sub></span></div>
        </div>
      </div>
    </div>
  );
};

export default CostInstruction;
